import { jsx as _jsx } from "react/jsx-runtime";
import { euclidean } from 'ml-distance-euclidean';
import { usePlotContext } from '../hooks';
import { closestPoint } from '../utils';
const HORIZONTAL = ['bottom', 'top'];
function infoFromMouse(event, axisContext, stateSeries) {
    const { clientX, clientY } = event;
    const { left, top } = event.currentTarget.getBoundingClientRect();
    // Calculate coordinates
    const xPosition = clientX - left;
    const yPosition = clientY - top;
    let coordinates = {};
    for (const key in axisContext) {
        const { scale, position } = axisContext[key];
        if (HORIZONTAL.includes(position)) {
            coordinates[key] = scale.invert(xPosition);
        }
        else {
            coordinates[key] = scale.invert(yPosition);
        }
    }
    return {
        event,
        coordinates,
        getClosest: (method) => closestCalculation(method, { x: xPosition, y: yPosition }, stateSeries, axisContext),
    };
}
function closestCalculation(method, coordinates, stateSeries, axisContext) {
    let series = {};
    switch (method) {
        case 'x': {
            for (const { id, x, data, label } of stateSeries) {
                if (data) {
                    const point = closestPoint(data, coordinates, (point, pos) => {
                        const { scale } = axisContext[x.axisId];
                        const xVal = pos[x.axisId];
                        return Math.abs(scale(point.x) - xVal);
                    });
                    series[id] = { point, label, axis: axisContext[x.axisId] };
                }
            }
            break;
        }
        case 'y': {
            for (const { id, y, data, label } of stateSeries) {
                if (data) {
                    const point = closestPoint(data, coordinates, (point, pos) => {
                        const { scale } = axisContext[y.axisId];
                        const yVal = pos[y.axisId];
                        return Math.abs(scale(point.y) - yVal);
                    });
                    series[id] = { point, label, axis: axisContext[y.axisId] };
                }
            }
            break;
        }
        case 'euclidean': {
            for (const { id, x, y, data, label } of stateSeries) {
                if (data) {
                    const point = closestPoint(data, coordinates, (point, pos) => {
                        const { scale: xScale } = axisContext[x.axisId];
                        const { scale: yScale } = axisContext[y.axisId];
                        const xVal = pos[x.axisId];
                        const yVal = pos[y.axisId];
                        return euclidean([xScale(point.x), yScale(point.y)], [xVal, yVal]);
                    });
                    series[id] = {
                        point,
                        label,
                        axis: { x: axisContext[x.axisId], y: axisContext[y.axisId] },
                    };
                }
            }
            break;
        }
        default: {
            throw new Error(`Unknown distance name: ${method}`);
        }
    }
    return series;
}
export default function Tracking({ onMouseMove, onClick, onMouseEnter, onMouseLeave, stateSeries, }) {
    const { axisContext, plotHeight, plotWidth } = usePlotContext();
    return (_jsx("rect", { width: plotWidth, height: plotHeight, className: "tracking", style: { fillOpacity: 0 }, onClick: (event) => {
            onClick(infoFromMouse(event, axisContext, stateSeries));
        }, onMouseMove: (event) => {
            onMouseMove(infoFromMouse(event, axisContext, stateSeries));
        }, onMouseEnter: (event) => onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(event), onMouseLeave: (event) => onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(event) }, void 0));
}
//# sourceMappingURL=Tracking.js.map